import axios from 'axios'

/**
 * temporary dummy data...
 */
export const tmpThirdPartyData = [
  {
    product: 'Figma',
    requested: '10/05/2024',
    department: 'All',
    status: '1',
  },
  {
    product: 'Adobe Photoshop',
    requested: '10/03/2024',
    department: 'DTS',
    status: '2',
  },
  {
    product: 'Adobe Flash',
    requested: '01/15/2025',
    department: 'DTS',
    status: '4',
  },
  {
    product: 'Adobe Xd',
    requested: '02/28/2025',
    department: 'UC',
    status: '4',
  },
  {
    product: 'Adobe Illustrator',
    requested: '03/10/2025',
    department: 'UC',
    status: '3',
  },
  {
    product: 'Adobe InDesign',
    requested: '04/22/2025',
    department: 'UC',
    status: '4',
  },
  {
    product: 'Adobe Premiere',
    requested: '05/19/2025',
    department: 'UC',
    status: '4',
  },
  {
    product: 'bitsyForms',
    requested: '12/23/2024',
    department: 'DTS',
    status: '3',
  },
  {
    product: 'OpenAI Enterprise',
    requested: '11/12/2024',
    department: 'DTS',
    status: '2',
  },
  {
    product: 'Linear Jira Alternative',
    requested: '05/27/2025',
    department: 'DTS',
    status: '1',
  },
]

/**
 *  This is our 'menu' of data fetches for use in DAG
 */
export function stakeholdersLeaderboard(){ return axios('/dag-api/get-leader/CAHS') }
export function thirdPartyTable(){ return axios('/dag-api/get-third-party') }